import { DatabaseService, NoteTemplate, NoteTemplateData } from "@/core";
import { NoteTemplateRepository } from "@/core/ports/repositories/note-template-repository";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getNoteTemplateRepository(
  databaseService: DatabaseService,
): NoteTemplateRepository {
  return getGenericRepository<NoteTemplate, NoteTemplateData>(
    () => DatabaseCollection.NOTE_TEMPLATES,
    databaseService,
  );
}
